import { i18n } from '@/plugins/i18n'
import { UserStatus } from '@/constants'

const fields = [
    {
        key: 'id',
        label: i18n.t('attributes.id'),
        _style: 'min-width:60px;',
        _classes: 'text-center',
    },
    {
        key: 'fullName',
        label: i18n.t('user.full_name'),
        _classes: 'text-center',
    },
    {
        key: 'phone',
        label: i18n.t('user.phone'),
        _classes: 'text-center',
    },
    {
        key: 'responsible',
        label: i18n.t('user.responsible'),
        _classes: 'text-center',
    },
    {
        key: 'status',
        label: i18n.t('user.status'),
        _classes: 'text-center',
    },
    {
        key: 'createdAt',
        label: i18n.t('user.created_at'),
        _classes: 'text-center',
    },
    {
        key: 'lastActivity',
        label: i18n.t('user.last_activity'),
        _classes: 'text-center',
    },
    {
        key: 'setupStatus',
        label: i18n.t('user.setup_status'),
        sorter: false,
        _classes: 'text-center',
    },
    {
        key: 'actions',
        label: i18n.t('actions'),
        _classes: 'text-center',
    },
]

export default fields

export const keywords = [
    {
        name: 'id',
        label: i18n.t('attributes.id')
    },
    {
        name: 'first_name',
        label: i18n.t('user.first_name'),
    },
    {
        name: 'last_name',
        label: i18n.t('user.last_name'),
    },
    {
        name: 'full_name',
        label: i18n.t('user.full_name')
    },
    {
        name: 'username',
        label: i18n.t('user.username')
    },
    {
        name: 'status',
        label: i18n.t('user.status'),
        type: 'callback',
        callback: (value) => {
            const statuses = {
                [UserStatus.BLOCK]: i18n.t('user.statuses.block'),
                [UserStatus.ACTIVE]: i18n.t('user.statuses.active'),
                [UserStatus.REMOVED]: i18n.t('user.statuses.removed'),
                [UserStatus.REMOVED_WHEN_PENDING]: i18n.t('user.statuses.removed_when_pending'),
            }

            return statuses[value] || ''
        }
    },
    {
        name: 'balance',
        label: i18n.t('user.balance'),
        type: 'currency',
    },
    {
        name: 'email',
        label: i18n.t('user.email')
    },
    {
        name: 'email_verified_at',
        label: i18n.t('user.email_verified_at'),
        type: 'datetime'
    },
    {
        name: 'last_login_time',
        label: i18n.t('user.last_login_time'),
        type: 'datetime'
    },
    {
        name: 'phone',
        label: i18n.t('user.phone')
    },
    {
        name: 'phone_verified_at',
        label: i18n.t('user.phone_verified_at'),
        type: 'datetime'
    },
    {
        name: 'register_date',
        label: i18n.t('user.register_date'),
        type: 'datetime'
    },
    {
        name: 'telephone',
        label: i18n.t('user.telephone')
    },
    {
        name: 'referrer_code',
        label: i18n.t('user.referrer_code')
    },
    {
        name: 'agreement',
        label: i18n.t('user.agreement'),
        type: 'link',
        anchor_text: i18n.t('view')
    },
    {
        name: 'agreed_at',
        label: i18n.t('user.agreed_at'),
        type: 'datetime'
    },
    {
        name: 'role',
        label: i18n.t('role._'),
        type: 'callback',
        callback: value => value.name
    },
    {
        name: 'is_admin',
        label: i18n.t('user.is_admin'),
        type: 'callback',
        callback: value => value ? i18n.t('yes') : i18n.t('no')
    }
]

export const sorts = [
    {
        label: i18n.t('sorter.desc', { attr: i18n.t('attributes.created_at') }),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', { attr: i18n.t('attributes.created_at') }),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', { attr: i18n.t('user.last_activity') }),
        value: {
            direction: 'asc',
            column: 'last_activity'
        }
    },
    {
        label: i18n.t('sorter.desc', { attr: i18n.t('user.last_activity') }),
        value: {
            direction: 'desc',
            column: 'last_activity'
        }
    },
]

export const store_users = {
    fields: [
        {
            key: 'id',
            label: i18n.t('attributes.id'),
        },
        {
            key: 'name',
            label: i18n.t('attributes.name'),
        },
        {
            key: 'website',
            label: i18n.t('store.website'),
        },
        {
            key: 'logo',
            label: i18n.t('store.logo'),
        },
    ],
    items: []
}

export const medias = {
    fields: [
        {
            key: 'id',
            label: i18n.t('attributes.id'),
        },
        {
            key: 'name',
            label: i18n.t('attributes.name'),
        },
        {
            key: 'created_at',
            label: i18n.t('media.created_at'),
        },
        {
            key: 'status',
            label: i18n.t('media.status'),
        },
        {
            key: 'url',
            label: 'url',
        },
        {
            key: 'type',
            label: i18n.t('media.type'),
        }
    ],
    items: []
}

export const stores = {
    fields: [
        {
            key: 'id',
            label: i18n.t('attributes.id'),
            sorter: true,
            _style: 'width:10%'
        },
        {
            key: 'name',
            label: i18n.t('store.name'),
            sorter: true,
            _style: 'width:25%;min-width:190px;'
        },
        {
            key: 'category',
            label: i18n.t('category._'),
            sorter: false,
        },
        {
            key: 'status',
            label: i18n.t('store.status'),
            sorter: false,
            _style: 'width:10%',
            _classes: 'text-center align-middle',
            policies: {
                store: ['change_status']
            },
        },
        {
            key: 'logo',
            label: i18n.t('store.logo'),
        },
    ],
    items: []
}